<template>
  <Layout
    :errors="errors"
    :resource="model"
    :title="trans(`models.${resourceType}.content.show.action`)"
    :toasts="toasts"
  >
    <template #right>
      <element-collection
        :columns="model.presentation.sections.core_data.info"
        :field-group="'info'"
        :model="model"
      ></element-collection>
    </template>
    <div v-if="model.data" class="card rounded-corner mb-3">
      <div class="card-body">
        <div class="model-title-bar">
          <div class="flex row pe-2">
            <div class="col flex-grow-1">
              <h5 class="card-title text-primary fw-bold text-uppercase">
                {{ trans(`models.${resourceType}.content.show.action`) }}
              </h5>
            </div>
            <div class="col flex-grow-0 align-self-center px-0">
              <resource-action
                :action="'demo'"
                :action-data="{iconClass: 'fa-solid fa-film', name: 'Demo'}"
                :button-class="'btn btn-primary text-secondary'"
                :model="model"
                :resource-type="resourceType"
                class="mx-2"
                show-name="true"
              ></resource-action>
            </div>
            <resource-action-buttons
              :button-class="'btn btn-primary text-secondary'"
              :model="model"
              :resource-type="resourceType"
              :source-action="'show'"
            ></resource-action-buttons>
          </div>
        </div>
        <p v-if="localModel.data.id" class="card-text">
          {{ trans(`models.${resourceType}.content.show.description`) }}
        </p>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-12">
        <element-collection
          :columns="model.presentation.sections.core_data.theme"
          :field-group="'theme'"
          :model="model"
        ></element-collection>
      </div>
    </div>
  </Layout>
</template>

<script>
import Card from '@kanrisha/components/Base/Card';
import ElementCollection from '@kanrisha/components/Presentation/ElementCollection.vue';
import MediaCollection from '@kanrisha/components/Presentation/MediaCollection.vue';
import Layout from '@kanrisha/Pages/Layout';
import ResourceAction from '@kanrisha/components/Links/ResourceAction';
import ResourceActionButtons from '@kanrisha/components/Links/ResourceActionButtons';
import ResourceCollection from '@kanrisha/components/ResourceCollection';
import { ref } from 'vue';
import useResource from '@kanrisha/composables/useResource';

export default {
  components: {
    Card,
    ElementCollection,
    MediaCollection,
    Layout,
    ResourceAction,
    ResourceActionButtons,
    ResourceCollection,
  },
  props: {
    aspectMenuItems: { type: Object, default: () => {} },
    model: { type: Object, default: () => {} },
    logEntries: { type: Object, default: () => {} },
    toasts: { type: Object, default: () => {} },
    errors: { type: Object, default: () => {} },
  },
  emits: ['addToast'],
  setup(props) {
    const localModel = ref(props.model);
    const { meta, resourceType } = useResource(props, props.model);

    return {
      localModel,
      meta,
      resourceType,
    };
  },
};
</script>
